import { Popover } from 'antd';
import { IconProps } from 'react-feather';
import { FaUndo } from 'react-icons/fa';

interface Props {
  onClick?: () => void;
  iconProps?: IconProps;
  disabled?: boolean;
}

const ReversalIcon: React.FC<Props> = ({ iconProps, disabled, onClick }) => {
  return (
    <Popover content={'Estornar'}>
      <FaUndo
        style={disabled ? { cursor: 'not-allowed' } : {}}
        size={18}
        cursor={'pointer'}
        onClick={!disabled ? onClick : undefined}
        {...iconProps}
      />
    </Popover>
  );
};

export default ReversalIcon;
